module.exports = __webpack_public_path__ + "static/media/Roots_alignment_modelling.2260f8d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/Roots_alignment_modelling.svg
// module id = 943
// module chunks = 0